import {ENDPOINT_URL} from '../constants';
const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function initCustomLogin(testUser) {
	return fetch(`${ENDPOINT_URL}/testcustomlogin`, {
		method: 'POST',
		mode: 'cors',
		credentials: 'include',
		headers,
		body: JSON.stringify(testUser),
	})
		.then((response) => {
			if (response.ok) {
				return response.json();
			}

			return Promise.reject(response);
		})
		.catch((error) => {
			console.log('error', error);
		});
}
